import { render, staticRenderFns } from "./StepItemUser.vue?vue&type=template&id=476d3abc&scoped=true&"
import script from "./StepItemUser.vue?vue&type=script&lang=js&"
export * from "./StepItemUser.vue?vue&type=script&lang=js&"
import style0 from "./StepItemUser.vue?vue&type=style&index=0&id=476d3abc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d3abc",
  null
  
)

export default component.exports